import * as React from 'react';

import type {User} from 'nutshell-core/users/users-types';

import {Stack} from 'shells/layout/stack/stack';

import type {Lead} from 'nutshell-graphql-types';

import {TimelineWidget} from '../../core-entity/widgets/timeline-widget';

import {ActivityWidgetWrapper} from '../deprecated/activities-widget/activity-widget-wrapper';
import {TopCustomFieldsWidgetOld} from '../deprecated/custom-fields/top-custom-fields-widget-old';

import {PipelineWidget} from './pipeline-widget/pipeline-widget';

import styles from './content-m1.module.css';

type Props = {
    lead: Lead;
    stagesetId: string | null | undefined;
    pipelineTasks: HTMLElement | null | undefined;
    pipelineTasksCount: number;
    onRenderPipelineTasks: () => void;
    onRenderCustomFields: () => void;
    customFields: HTMLElement | null | undefined;
    customFieldsCount: number;
    scrollContainerRef: HTMLDivElement | null | undefined;
    user: User | null | undefined;
};

export function ContentM1(props: Props) {
    const contentRef = React.useRef<HTMLDivElement | null>(null);

    return (
        <div ref={contentRef} className={styles.content}>
            <PipelineWidget
                lead={props.lead}
                pipelineTasks={props.pipelineTasks}
                pipelineTasksCount={props.pipelineTasksCount}
                onRenderLeadMarkup={props.onRenderPipelineTasks}
            />
            {props.customFields && (
                <TopCustomFieldsWidgetOld
                    stagesetId={props.stagesetId}
                    customFields={props.customFields}
                    customFieldsCount={props.customFieldsCount}
                    onRenderLeadMarkup={props.onRenderCustomFields}
                    user={props.user}
                />
            )}
            <Stack
                isHorizontal={true}
                spacing={8}
                justifyContent='space-between'
                isFullWidth={true}
            >
                <div className={styles['m1-half-width-section']}></div>
                <div className={styles['m1-half-width-section']}>
                    <ActivityWidgetWrapper leadId={props.lead.id} />
                </div>
            </Stack>
            {props.lead && (
                <TimelineWidget
                    entityId={props.lead.id}
                    entityName='Leads'
                    scrollContainerRef={props.scrollContainerRef}
                />
            )}
        </div>
    );
}
